module.exports = __webpack_public_path__ + "img/baner_02_03.64948dec.jpg";